<header (click)="toggleContent()" [ngClass]="{ 'toggle-position-after': togglePosition === 'after', interactive: interactive }">
    @if (togglePosition === 'before') {
        @if (interactive) {
            <app-icon centered
                      name="chevron_down" />
        }
    }

    <div class="headline">
        <ng-content select="[header]" />
    </div>

    @if (togglePosition === 'after') {
        @if (interactive) {
            <app-icon centered
                      name="chevron_down" />
        }
    }

</header>

<main>
    <ng-content />
</main>

@if (!isOpen && summary) {
    <p class="summary">
        {{ summary }}
    </p>
}
